import { axiosSwagger } from "@/axios";


const sortLocationsDeep = (locations = []) => {
  return [...(locations || [])]
    .map((location) => ({
      ...location,
      childLocations: sortLocationsDeep(location.childLocations || []),
    }))
    .sort((a, b) =>
      (a?.location || "").localeCompare((b?.location || ""), undefined, {
        sensitivity: "base",
        numeric: true,
      })
    );
};



export const state = {
  // set location
  setLocation: {
    loading: false,
    data: [],

    selectedData: null,
  }
}


export const getters = {
}


export const mutations = {
  // SET LOCATION
  loading: (state, loading) => {
    state.setLocation.loading = loading;
  },
  setData: (state, data) => {
    state.setLocation.data = data;
  },
  selectData: (state, data) => {
    state.setLocation.selectedData = data;
  },
}


export const actions = {
  // SET LOCATION
  async readSetLocation({ commit }, id) {
    commit("loading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    if(id !== null){
      return await axiosSwagger
        .get(`/api/FileLocation/Child/${id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          const sortedData = sortLocationsDeep(response.data);

          commit("setData", sortedData);
          commit("loading", false);

          return {
            ...response,
            data: sortedData,
          };
        })
        .catch(() => {
          commit("loading", false);
        });
    }
    else{
      return await axiosSwagger
        .get(`/api/FileLocation/My/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          const sortedData = sortLocationsDeep(response.data);

          commit("setData", sortedData);
          commit("loading", false);

          return {
            ...response,
            data: sortedData,
          };
        })
        .catch(() => {
          commit("loading", false);
        });
    }
  }
}

